import { CLOSE_ROLE_MODAL, SET_ROLE_SELECT } from '../reducers/modals'

export const set_role_modal = (
  position,
  current,
  onSelect,
  hasDelete,
  onDelete,
  blackListRoles
) => {
  return (dispatch) => {
    dispatch({
      type: SET_ROLE_SELECT,
      position,
      current,
      onSelect,
      hasDelete,
      onDelete,
      blackListRoles,
    })
  }
}

export const close_role_modal = () => {
  return (dispatch) => {
    dispatch({ type: CLOSE_ROLE_MODAL })
  }
}
